import React from "react";

import { useMediaQuery } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";

import useDailyReadPlayerDimensions from "@app/analytics/hooks/domHelpers/useDailyReadPlayerDimensions";
import theme from "@app/analytics/theme";

const ReportFeedbackSnackbar = ({
  show,
  children,
}: {
  show: boolean;
  children: React.ReactNode;
}) => {
  const inDesktopView = useMediaQuery(theme.breakpoints.up("sm"));
  const dailyReadPlayerDimensions = useDailyReadPlayerDimensions();

  // the snackbar has a default offset of 24 px in desktop view, which is a
  // little too big when stacked on top of the player, so just do half of that
  const marginBottomOffset = inDesktopView ? 12 : 0;
  const verticalOffset = dailyReadPlayerDimensions.height - marginBottomOffset;

  return (
    <Snackbar
      open={show}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      sx={{
        zIndex: 90, // must be lower than MR loading overlay,
        transition: "margin 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        // show the feedback snackbar above the daily read player, if visible
        marginBottom: `${verticalOffset}px`,
        // the following styles are necessary for <"sm" breakpoint;
        // the anchorOrigin will get ignored and the snackbar defaults to
        // full-width and left-aligned
        width: "fit-content",
        left: "unset",
        right: 24, // same as the other views' "right" value
      }}
    >
      {/* Snackbar component tries to force style onto its direct descendant; span is a buffer against that */}
      <span>{children}</span>
    </Snackbar>
  );
};

export default ReportFeedbackSnackbar;
